import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["register"],
    _excluded2 = ["onPress", "onPressChange", "onPressStart", "onPressEnd", "onPressUp", "isDisabled", "isPressed", "preventFocusOnPress", "shouldCancelOnPointerExit", "allowTextSelectionOnPress", "ref"],
    _excluded3 = ["children"],
    _excluded4 = ["children"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeProps as $d6MJ8$mergeProps, useSyncRef as $d6MJ8$useSyncRef, useGlobalListeners as $d6MJ8$useGlobalListeners, focusWithoutScrolling as $d6MJ8$focusWithoutScrolling, isIOS as $d6MJ8$isIOS, runAfterTransition as $d6MJ8$runAfterTransition, isMac as $d6MJ8$isMac, useEvent as $d6MJ8$useEvent, useDescription as $d6MJ8$useDescription } from "@react-aria/utils";
import $d6MJ8$react, { useRef as $d6MJ8$useRef, useContext as $d6MJ8$useContext, useState as $d6MJ8$useState, useMemo as $d6MJ8$useMemo, useEffect as $d6MJ8$useEffect, useCallback as $d6MJ8$useCallback } from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $28aa772934c24805$exports = {};
$parcel$export($28aa772934c24805$exports, "Pressable", function () {
  return $28aa772934c24805$export$27c701ed9e449e99;
});
var $b468497b34dcb8dd$exports = {};
$parcel$export($b468497b34dcb8dd$exports, "usePress", function () {
  return $b468497b34dcb8dd$export$45712eceda6fad21;
}); // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually

var $cd0dbdeabf637843$var$state = 'default';
var $cd0dbdeabf637843$var$savedUserSelect = '';
var $cd0dbdeabf637843$var$modifiedElementMap = new WeakMap();

function $cd0dbdeabf637843$export$16a4697467175487(target) {
  if ($d6MJ8$isIOS()) {
    if ($cd0dbdeabf637843$var$state === 'default') {
      $cd0dbdeabf637843$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
      document.documentElement.style.webkitUserSelect = 'none';
    }

    $cd0dbdeabf637843$var$state = 'disabled';
  } else if (target) {
    // If not iOS, store the target's original user-select and change to user-select: none
    // Ignore state since it doesn't apply for non iOS
    $cd0dbdeabf637843$var$modifiedElementMap.set(target, target.style.userSelect);
    target.style.userSelect = 'none';
  }
}

function $cd0dbdeabf637843$export$b0d6fa1ab32e3295(target) {
  if ($d6MJ8$isIOS()) {
    // If the state is already default, there's nothing to do.
    // If it is restoring, then there's no need to queue a second restore.
    if ($cd0dbdeabf637843$var$state !== 'disabled') return;
    $cd0dbdeabf637843$var$state = 'restoring'; // There appears to be a delay on iOS where selection still might occur
    // after pointer up, so wait a bit before removing user-select.

    setTimeout(function () {
      // Wait for any CSS transitions to complete so we don't recompute style
      // for the whole page in the middle of the animation and cause jank.
      $d6MJ8$runAfterTransition(function () {
        // Avoid race conditions
        if ($cd0dbdeabf637843$var$state === 'restoring') {
          if (document.documentElement.style.webkitUserSelect === 'none') document.documentElement.style.webkitUserSelect = $cd0dbdeabf637843$var$savedUserSelect || '';
          $cd0dbdeabf637843$var$savedUserSelect = '';
          $cd0dbdeabf637843$var$state = 'default';
        }
      });
    }, 300);
  } else // If not iOS, restore the target's original user-select if any
    // Ignore state since it doesn't apply for non iOS
    if (target && $cd0dbdeabf637843$var$modifiedElementMap.has(target)) {
      var targetOldUserSelect = $cd0dbdeabf637843$var$modifiedElementMap.get(target);
      if (target.style.userSelect === 'none') target.style.userSelect = targetOldUserSelect;
      if (target.getAttribute('style') === '') target.removeAttribute('style');
      $cd0dbdeabf637843$var$modifiedElementMap.delete(target);
    }
}

function $3004588ac0f775f8$export$60278871457622de(event) {
  // JAWS/NVDA with Firefox.
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  return event.detail === 0 && !event.pointerType;
}

var $8e24aea97df378f7$export$5165eccb35aaadb5 = $d6MJ8$react.createContext(null);
$8e24aea97df378f7$export$5165eccb35aaadb5.displayName = 'PressResponderContext';

function $b468497b34dcb8dd$var$usePressResponderContext(props) {
  // Consume context from <PressResponder> and merge with props.
  var context = $d6MJ8$useContext($8e24aea97df378f7$export$5165eccb35aaadb5);

  if (context) {
    var register = context.register,
        contextProps = _objectWithoutProperties(context, _excluded);

    props = $d6MJ8$mergeProps(contextProps, props);
    register();
  }

  $d6MJ8$useSyncRef(context, props.ref);
  return props;
}

function $b468497b34dcb8dd$export$45712eceda6fad21(props) {
  var _$b468497b34dcb8dd$va = $b468497b34dcb8dd$var$usePressResponderContext(props),
      onPress1 = _$b468497b34dcb8dd$va.onPress,
      onPressChange1 = _$b468497b34dcb8dd$va.onPressChange,
      onPressStart1 = _$b468497b34dcb8dd$va.onPressStart,
      onPressEnd1 = _$b468497b34dcb8dd$va.onPressEnd,
      onPressUp1 = _$b468497b34dcb8dd$va.onPressUp,
      isDisabled1 = _$b468497b34dcb8dd$va.isDisabled,
      isPressedProp = _$b468497b34dcb8dd$va.isPressed,
      preventFocusOnPress = _$b468497b34dcb8dd$va.preventFocusOnPress,
      shouldCancelOnPointerExit = _$b468497b34dcb8dd$va.shouldCancelOnPointerExit,
      allowTextSelectionOnPress = _$b468497b34dcb8dd$va.allowTextSelectionOnPress,
      _ = _$b468497b34dcb8dd$va.ref,
      domProps = _objectWithoutProperties(_$b468497b34dcb8dd$va, _excluded2);

  var propsRef = $d6MJ8$useRef(null);
  propsRef.current = {
    onPress: onPress1,
    onPressChange: onPressChange1,
    onPressStart: onPressStart1,
    onPressEnd: onPressEnd1,
    onPressUp: onPressUp1,
    isDisabled: isDisabled1,
    shouldCancelOnPointerExit: shouldCancelOnPointerExit
  };

  var _$d6MJ8$useState = $d6MJ8$useState(false),
      _$d6MJ8$useState2 = _slicedToArray(_$d6MJ8$useState, 2),
      isPressed = _$d6MJ8$useState2[0],
      setPressed = _$d6MJ8$useState2[1];

  var ref = $d6MJ8$useRef({
    isPressed: false,
    ignoreEmulatedMouseEvents: false,
    ignoreClickAfterPress: false,
    didFirePressStart: false,
    activePointerId: null,
    target: null,
    isOverTarget: false,
    pointerType: null
  });

  var _$d6MJ8$useGlobalList = $d6MJ8$useGlobalListeners(),
      addGlobalListener = _$d6MJ8$useGlobalList.addGlobalListener,
      removeAllGlobalListeners = _$d6MJ8$useGlobalList.removeAllGlobalListeners;

  var pressProps1 = $d6MJ8$useMemo(function () {
    var state = ref.current;

    var triggerPressStart = function triggerPressStart(originalEvent, pointerType) {
      var _propsRef$current = propsRef.current,
          onPressStart = _propsRef$current.onPressStart,
          onPressChange = _propsRef$current.onPressChange,
          isDisabled = _propsRef$current.isDisabled;
      if (isDisabled || state.didFirePressStart) return;
      if (onPressStart) onPressStart({
        type: 'pressstart',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
      if (onPressChange) onPressChange(true);
      state.didFirePressStart = true;
      setPressed(true);
    };

    var triggerPressEnd = function triggerPressEnd(originalEvent, pointerType) {
      var wasPressed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _propsRef$current2 = propsRef.current,
          onPressEnd = _propsRef$current2.onPressEnd,
          onPressChange = _propsRef$current2.onPressChange,
          onPress = _propsRef$current2.onPress,
          isDisabled = _propsRef$current2.isDisabled;
      if (!state.didFirePressStart) return;
      state.ignoreClickAfterPress = true;
      state.didFirePressStart = false;
      if (onPressEnd) onPressEnd({
        type: 'pressend',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
      if (onPressChange) onPressChange(false);
      setPressed(false);
      if (onPress && wasPressed && !isDisabled) onPress({
        type: 'press',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };

    var triggerPressUp = function triggerPressUp(originalEvent, pointerType) {
      var _propsRef$current3 = propsRef.current,
          onPressUp = _propsRef$current3.onPressUp,
          isDisabled = _propsRef$current3.isDisabled;
      if (isDisabled) return;
      if (onPressUp) onPressUp({
        type: 'pressup',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };

    var cancel = function cancel(e) {
      if (state.isPressed) {
        if (state.isOverTarget) triggerPressEnd($b468497b34dcb8dd$var$createEvent(state.target, e), state.pointerType, false);
        state.isPressed = false;
        state.isOverTarget = false;
        state.activePointerId = null;
        state.pointerType = null;
        removeAllGlobalListeners();
        if (!allowTextSelectionOnPress) $cd0dbdeabf637843$export$b0d6fa1ab32e3295(state.target);
      }
    };

    var pressProps = {
      onKeyDown: function onKeyDown(e) {
        if ($b468497b34dcb8dd$var$isValidKeyboardEvent(e.nativeEvent) && e.currentTarget.contains(e.target)) {
          if ($b468497b34dcb8dd$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
          e.stopPropagation(); // If the event is repeating, it may have started on a different element
          // after which focus moved to the current element. Ignore these events and
          // only handle the first key down event.

          if (!state.isPressed && !e.repeat) {
            state.target = e.currentTarget;
            state.isPressed = true;
            triggerPressStart(e, 'keyboard'); // Focus may move before the key up event, so register the event on the document
            // instead of the same element where the key down event occurred.

            addGlobalListener(document, 'keyup', onKeyUp, false);
          }
        }
      },
      onKeyUp: function onKeyUp(e) {
        if ($b468497b34dcb8dd$var$isValidKeyboardEvent(e.nativeEvent) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($b468497b34dcb8dd$var$createEvent(state.target, e), 'keyboard');
      },
      onClick: function onClick(e) {
        if (e && !e.currentTarget.contains(e.target)) return;

        if (e && e.button === 0) {
          e.stopPropagation();
          if (isDisabled1) e.preventDefault(); // If triggered from a screen reader or by using element.click(),
          // trigger as if it were a keyboard click.

          if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === 'virtual' || $3004588ac0f775f8$export$60278871457622de(e.nativeEvent))) {
            // Ensure the element receives focus (VoiceOver on iOS does not do this)
            if (!isDisabled1 && !preventFocusOnPress) $d6MJ8$focusWithoutScrolling(e.currentTarget);
            triggerPressStart(e, 'virtual');
            triggerPressUp(e, 'virtual');
            triggerPressEnd(e, 'virtual');
          }

          state.ignoreEmulatedMouseEvents = false;
          state.ignoreClickAfterPress = false;
        }
      }
    };

    var onKeyUp = function onKeyUp(e) {
      if (state.isPressed && $b468497b34dcb8dd$var$isValidKeyboardEvent(e)) {
        if ($b468497b34dcb8dd$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
        e.stopPropagation();
        state.isPressed = false;
        var target = e.target;
        triggerPressEnd($b468497b34dcb8dd$var$createEvent(state.target, e), 'keyboard', state.target.contains(target));
        removeAllGlobalListeners(); // If the target is a link, trigger the click method to open the URL,
        // but defer triggering pressEnd until onClick event handler.

        if (state.target.contains(target) && $b468497b34dcb8dd$var$isHTMLAnchorLink(state.target) || state.target.getAttribute('role') === 'link') state.target.click();
      }
    };

    if (typeof PointerEvent !== 'undefined') {
      pressProps.onPointerDown = function (e) {
        // Only handle left clicks, and ignore events that bubbled through portals.
        if (e.button !== 0 || !e.currentTarget.contains(e.target)) return; // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
        // Ignore and let the onClick handler take care of it instead.
        // https://bugs.webkit.org/show_bug.cgi?id=222627
        // https://bugs.webkit.org/show_bug.cgi?id=223202

        if ($b468497b34dcb8dd$var$isVirtualPointerEvent(e.nativeEvent)) {
          state.pointerType = 'virtual';
          return;
        } // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on pointer down and handle focusing the pressable element ourselves.


        if ($b468497b34dcb8dd$var$shouldPreventDefault(e.target)) e.preventDefault();
        state.pointerType = e.pointerType;
        e.stopPropagation();

        if (!state.isPressed) {
          state.isPressed = true;
          state.isOverTarget = true;
          state.activePointerId = e.pointerId;
          state.target = e.currentTarget;
          if (!isDisabled1 && !preventFocusOnPress) $d6MJ8$focusWithoutScrolling(e.currentTarget);
          if (!allowTextSelectionOnPress) $cd0dbdeabf637843$export$16a4697467175487(state.target);
          triggerPressStart(e, state.pointerType);
          addGlobalListener(document, 'pointermove', onPointerMove, false);
          addGlobalListener(document, 'pointerup', onPointerUp, false);
          addGlobalListener(document, 'pointercancel', onPointerCancel, false);
        }
      };

      pressProps.onMouseDown = function (e) {
        if (!e.currentTarget.contains(e.target)) return;

        if (e.button === 0) {
          // Chrome and Firefox on touch Windows devices require mouse down events
          // to be canceled in addition to pointer events, or an extra asynchronous
          // focus event will be fired.
          if ($b468497b34dcb8dd$var$shouldPreventDefault(e.target)) e.preventDefault();
          e.stopPropagation();
        }
      };

      pressProps.onPointerUp = function (e) {
        // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
        if (!e.currentTarget.contains(e.target) || state.pointerType === 'virtual') return; // Only handle left clicks
        // Safari on iOS sometimes fires pointerup events, even
        // when the touch isn't over the target, so double check.

        if (e.button === 0 && $b468497b34dcb8dd$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
      }; // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
      // Use pointer move events instead to implement our own hit testing.
      // See https://bugs.webkit.org/show_bug.cgi?id=199803


      var onPointerMove = function onPointerMove(e) {
        if (e.pointerId !== state.activePointerId) return;

        if ($b468497b34dcb8dd$var$isOverTarget(e, state.target)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart($b468497b34dcb8dd$var$createEvent(state.target, e), state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd($b468497b34dcb8dd$var$createEvent(state.target, e), state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };

      var onPointerUp = function onPointerUp(e) {
        if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
          if ($b468497b34dcb8dd$var$isOverTarget(e, state.target)) triggerPressEnd($b468497b34dcb8dd$var$createEvent(state.target, e), state.pointerType);else if (state.isOverTarget) triggerPressEnd($b468497b34dcb8dd$var$createEvent(state.target, e), state.pointerType, false);
          state.isPressed = false;
          state.isOverTarget = false;
          state.activePointerId = null;
          state.pointerType = null;
          removeAllGlobalListeners();
          if (!allowTextSelectionOnPress) $cd0dbdeabf637843$export$b0d6fa1ab32e3295(state.target);
        }
      };

      var onPointerCancel = function onPointerCancel(e) {
        cancel(e);
      };

      pressProps.onDragStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return; // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.

        cancel(e);
      };
    } else {
      pressProps.onMouseDown = function (e) {
        // Only handle left clicks
        if (e.button !== 0 || !e.currentTarget.contains(e.target)) return; // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on mouse down and handle focusing the pressable element ourselves.

        if ($b468497b34dcb8dd$var$shouldPreventDefault(e.target)) e.preventDefault();
        e.stopPropagation();
        if (state.ignoreEmulatedMouseEvents) return;
        state.isPressed = true;
        state.isOverTarget = true;
        state.target = e.currentTarget;
        state.pointerType = $3004588ac0f775f8$export$60278871457622de(e.nativeEvent) ? 'virtual' : 'mouse';
        if (!isDisabled1 && !preventFocusOnPress) $d6MJ8$focusWithoutScrolling(e.currentTarget);
        triggerPressStart(e, state.pointerType);
        addGlobalListener(document, 'mouseup', onMouseUp, false);
      };

      pressProps.onMouseEnter = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();

        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = true;
          triggerPressStart(e, state.pointerType);
        }
      };

      pressProps.onMouseLeave = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();

        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };

      pressProps.onMouseUp = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
      };

      var onMouseUp = function onMouseUp(e) {
        // Only handle left clicks
        if (e.button !== 0) return;
        state.isPressed = false;
        removeAllGlobalListeners();

        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }

        if ($b468497b34dcb8dd$var$isOverTarget(e, state.target)) triggerPressEnd($b468497b34dcb8dd$var$createEvent(state.target, e), state.pointerType);else if (state.isOverTarget) triggerPressEnd($b468497b34dcb8dd$var$createEvent(state.target, e), state.pointerType, false);
        state.isOverTarget = false;
      };

      pressProps.onTouchStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        var touch = $b468497b34dcb8dd$var$getTouchFromEvent(e.nativeEvent);
        if (!touch) return;
        state.activePointerId = touch.identifier;
        state.ignoreEmulatedMouseEvents = true;
        state.isOverTarget = true;
        state.isPressed = true;
        state.target = e.currentTarget;
        state.pointerType = 'touch'; // Due to browser inconsistencies, especially on mobile browsers, we prevent default
        // on the emulated mouse event and handle focusing the pressable element ourselves.

        if (!isDisabled1 && !preventFocusOnPress) $d6MJ8$focusWithoutScrolling(e.currentTarget);
        if (!allowTextSelectionOnPress) $cd0dbdeabf637843$export$16a4697467175487(state.target);
        triggerPressStart(e, state.pointerType);
        addGlobalListener(window, 'scroll', onScroll, true);
      };

      pressProps.onTouchMove = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (!state.isPressed) return;
        var touch = $b468497b34dcb8dd$var$getTouchById(e.nativeEvent, state.activePointerId);

        if (touch && $b468497b34dcb8dd$var$isOverTarget(touch, e.currentTarget)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart(e, state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };

      pressProps.onTouchEnd = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (!state.isPressed) return;
        var touch = $b468497b34dcb8dd$var$getTouchById(e.nativeEvent, state.activePointerId);

        if (touch && $b468497b34dcb8dd$var$isOverTarget(touch, e.currentTarget)) {
          triggerPressUp(e, state.pointerType);
          triggerPressEnd(e, state.pointerType);
        } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);

        state.isPressed = false;
        state.activePointerId = null;
        state.isOverTarget = false;
        state.ignoreEmulatedMouseEvents = true;
        if (!allowTextSelectionOnPress) $cd0dbdeabf637843$export$b0d6fa1ab32e3295(state.target);
        removeAllGlobalListeners();
      };

      pressProps.onTouchCancel = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (state.isPressed) cancel(e);
      };

      var onScroll = function onScroll(e) {
        if (state.isPressed && e.target.contains(state.target)) cancel({
          currentTarget: state.target,
          shiftKey: false,
          ctrlKey: false,
          metaKey: false,
          altKey: false
        });
      };

      pressProps.onDragStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        cancel(e);
      };
    }

    return pressProps;
  }, [addGlobalListener, isDisabled1, preventFocusOnPress, removeAllGlobalListeners, allowTextSelectionOnPress]); // Remove user-select: none in case component unmounts immediately after pressStart
  // eslint-disable-next-line arrow-body-style

  $d6MJ8$useEffect(function () {
    return function () {
      if (!allowTextSelectionOnPress) $cd0dbdeabf637843$export$b0d6fa1ab32e3295(ref.current.target);
    };
  }, [allowTextSelectionOnPress]);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: $d6MJ8$mergeProps(domProps, pressProps1)
  };
}

function $b468497b34dcb8dd$var$isHTMLAnchorLink(target) {
  return target.tagName === 'A' && target.hasAttribute('href');
}

function $b468497b34dcb8dd$var$isValidKeyboardEvent(event) {
  var key = event.key,
      code = event.code,
      target = event.target;
  var element = target;
  var tagName = element.tagName,
      isContentEditable = element.isContentEditable;
  var role = element.getAttribute('role'); // Accessibility for keyboards. Space and Enter only.
  // "Spacebar" is for IE 11

  return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && tagName !== 'INPUT' && tagName !== 'TEXTAREA' && isContentEditable !== true && (!$b468497b34dcb8dd$var$isHTMLAnchorLink(element) || role === 'button' && key !== 'Enter') && // An element with role='link' should only trigger with Enter key
  !(role === 'link' && key !== 'Enter');
}

function $b468497b34dcb8dd$var$getTouchFromEvent(event) {
  var targetTouches = event.targetTouches;
  if (targetTouches.length > 0) return targetTouches[0];
  return null;
}

function $b468497b34dcb8dd$var$getTouchById(event, pointerId) {
  var changedTouches = event.changedTouches;

  for (var i = 0; i < changedTouches.length; i++) {
    var touch = changedTouches[i];
    if (touch.identifier === pointerId) return touch;
  }

  return null;
}

function $b468497b34dcb8dd$var$createEvent(target, e) {
  return {
    currentTarget: target,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey
  };
}

function $b468497b34dcb8dd$var$getPointClientRect(point) {
  var offsetX = point.width / 2 || point.radiusX || 0;
  var offsetY = point.height / 2 || point.radiusY || 0;
  return {
    top: point.clientY - offsetY,
    right: point.clientX + offsetX,
    bottom: point.clientY + offsetY,
    left: point.clientX - offsetX
  };
}

function $b468497b34dcb8dd$var$areRectanglesOverlapping(a, b) {
  // check if they cannot overlap on x axis
  if (a.left > b.right || b.left > a.right) return false; // check if they cannot overlap on y axis

  if (a.top > b.bottom || b.top > a.bottom) return false;
  return true;
}

function $b468497b34dcb8dd$var$isOverTarget(point, target) {
  var rect = target.getBoundingClientRect();
  var pointRect = $b468497b34dcb8dd$var$getPointClientRect(point);
  return $b468497b34dcb8dd$var$areRectanglesOverlapping(rect, pointRect);
}

function $b468497b34dcb8dd$var$shouldPreventDefault(target) {
  // We cannot prevent default if the target is inside a draggable element.
  return !target.closest('[draggable="true"]');
}

function $b468497b34dcb8dd$var$shouldPreventDefaultKeyboard(target) {
  return !((target.tagName === 'INPUT' || target.tagName === 'BUTTON') && target.type === 'submit');
}

function $b468497b34dcb8dd$var$isVirtualPointerEvent(event) {
  // If the pointer size is zero, then we assume it's from a screen reader.
  // Android TalkBack double tap will sometimes return a event with width and height of 1
  // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
  // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
  // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0;
}

var $28aa772934c24805$export$27c701ed9e449e99 = /*#__PURE__*/$d6MJ8$react.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded3);

  var newRef = $d6MJ8$useRef();
  ref = ref !== null && ref !== void 0 ? ref : newRef;

  var _$b468497b34dcb8dd$ex = $b468497b34dcb8dd$export$45712eceda6fad21(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })),
      pressProps = _$b468497b34dcb8dd$ex.pressProps;

  var child = $d6MJ8$react.Children.only(children);
  return /*#__PURE__*/$d6MJ8$react.cloneElement(child, // @ts-ignore
  _objectSpread({
    ref: ref
  }, $d6MJ8$mergeProps(child.props, pressProps)));
});
var $68900e0904c93fdc$exports = {};
$parcel$export($68900e0904c93fdc$exports, "PressResponder", function () {
  return $68900e0904c93fdc$export$3351871ee4b288b8;
});
var $68900e0904c93fdc$export$3351871ee4b288b8 = /*#__PURE__*/$d6MJ8$react.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded4);

  var isRegistered = $d6MJ8$useRef(false);
  var prevContext = $d6MJ8$useContext($8e24aea97df378f7$export$5165eccb35aaadb5);
  var context = $d6MJ8$mergeProps(prevContext || {}, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref),
    register: function register() {
      isRegistered.current = true;
      if (prevContext) prevContext.register();
    }
  }));
  $d6MJ8$useSyncRef(prevContext, ref);
  $d6MJ8$useEffect(function () {
    if (!isRegistered.current) console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
  }, []);
  return /*#__PURE__*/$d6MJ8$react.createElement($8e24aea97df378f7$export$5165eccb35aaadb5.Provider, {
    value: context
  }, children);
});
var $226b63c52f1613ce$exports = {};
$parcel$export($226b63c52f1613ce$exports, "useFocus", function () {
  return $226b63c52f1613ce$export$f8168d8dd8fd66e6;
});

function $226b63c52f1613ce$export$f8168d8dd8fd66e6(props) {
  if (props.isDisabled) return {
    focusProps: {}
  };
  var onFocus, onBlur;
  if (props.onFocus || props.onFocusChange) onFocus = function onFocus(e) {
    if (e.target === e.currentTarget) {
      if (props.onFocus) props.onFocus(e);
      if (props.onFocusChange) props.onFocusChange(true);
    }
  };
  if (props.onBlur || props.onFocusChange) onBlur = function onBlur(e) {
    if (e.target === e.currentTarget) {
      if (props.onBlur) props.onBlur(e);
      if (props.onFocusChange) props.onFocusChange(false);
    }
  };
  return {
    focusProps: {
      onFocus: onFocus,
      onBlur: onBlur
    }
  };
}

var $49c2914eac614f98$exports = {};
$parcel$export($49c2914eac614f98$exports, "isFocusVisible", function () {
  return $49c2914eac614f98$export$b9b3dfddab17db27;
});
$parcel$export($49c2914eac614f98$exports, "getInteractionModality", function () {
  return $49c2914eac614f98$export$630ff653c5ada6a9;
});
$parcel$export($49c2914eac614f98$exports, "setInteractionModality", function () {
  return $49c2914eac614f98$export$8397ddfc504fdb9a;
});
$parcel$export($49c2914eac614f98$exports, "useInteractionModality", function () {
  return $49c2914eac614f98$export$98e20ec92f614cfe;
});
$parcel$export($49c2914eac614f98$exports, "useFocusVisible", function () {
  return $49c2914eac614f98$export$ffd9e5021c1fb2d6;
});
$parcel$export($49c2914eac614f98$exports, "useFocusVisibleListener", function () {
  return $49c2914eac614f98$export$ec71b4b83ac08ec3;
});
var $49c2914eac614f98$var$currentModality = null;
var $49c2914eac614f98$var$changeHandlers = new Set();
var $49c2914eac614f98$var$hasSetupGlobalListeners = false;
var $49c2914eac614f98$var$hasEventBeforeFocus = false;
var $49c2914eac614f98$var$hasBlurredWindowRecently = false; // Only Tab or Esc keys will make focus visible on text input elements

var $49c2914eac614f98$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: true,
  Escape: true
};

function $49c2914eac614f98$var$triggerChangeHandlers(modality, e) {
  var _iterator = _createForOfIteratorHelper($49c2914eac614f98$var$changeHandlers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handler = _step.value;
      handler(modality, e);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */


function $49c2914eac614f98$var$isValidKey(e) {
  // Control and Shift keys trigger when navigating back to the tab with keyboard.
  return !(e.metaKey || !$d6MJ8$isMac() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}

function $49c2914eac614f98$var$handleKeyboardEvent(e) {
  $49c2914eac614f98$var$hasEventBeforeFocus = true;

  if ($49c2914eac614f98$var$isValidKey(e)) {
    $49c2914eac614f98$var$currentModality = 'keyboard';
    $49c2914eac614f98$var$triggerChangeHandlers('keyboard', e);
  }
}

function $49c2914eac614f98$var$handlePointerEvent(e) {
  $49c2914eac614f98$var$currentModality = 'pointer';

  if (e.type === 'mousedown' || e.type === 'pointerdown') {
    $49c2914eac614f98$var$hasEventBeforeFocus = true;
    $49c2914eac614f98$var$triggerChangeHandlers('pointer', e);
  }
}

function $49c2914eac614f98$var$handleClickEvent(e) {
  if ($3004588ac0f775f8$export$60278871457622de(e)) {
    $49c2914eac614f98$var$hasEventBeforeFocus = true;
    $49c2914eac614f98$var$currentModality = 'virtual';
  }
}

function $49c2914eac614f98$var$handleFocusEvent(e) {
  // Firefox fires two extra focus events when the user first clicks into an iframe:
  // first on the window, then on the document. We ignore these events so they don't
  // cause keyboard focus rings to appear.
  if (e.target === window || e.target === document) return; // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
  // This occurs, for example, when navigating a form with the next/previous buttons on iOS.

  if (!$49c2914eac614f98$var$hasEventBeforeFocus && !$49c2914eac614f98$var$hasBlurredWindowRecently) {
    $49c2914eac614f98$var$currentModality = 'virtual';
    $49c2914eac614f98$var$triggerChangeHandlers('virtual', e);
  }

  $49c2914eac614f98$var$hasEventBeforeFocus = false;
  $49c2914eac614f98$var$hasBlurredWindowRecently = false;
}

function $49c2914eac614f98$var$handleWindowBlur() {
  // When the window is blurred, reset state. This is necessary when tabbing out of the window,
  // for example, since a subsequent focus event won't be fired.
  $49c2914eac614f98$var$hasEventBeforeFocus = false;
  $49c2914eac614f98$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */


function $49c2914eac614f98$var$setupGlobalFocusEvents() {
  if (typeof window === 'undefined' || $49c2914eac614f98$var$hasSetupGlobalListeners) return; // Programmatic focus() calls shouldn't affect the current input modality.
  // However, we need to detect other cases when a focus event occurs without
  // a preceding user event (e.g. screen reader focus). Overriding the focus
  // method on HTMLElement.prototype is a bit hacky, but works.

  var focus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function () {
    $49c2914eac614f98$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };

  document.addEventListener('keydown', $49c2914eac614f98$var$handleKeyboardEvent, true);
  document.addEventListener('keyup', $49c2914eac614f98$var$handleKeyboardEvent, true);
  document.addEventListener('click', $49c2914eac614f98$var$handleClickEvent, true); // Register focus events on the window so they are sure to happen
  // before React's event listeners (registered on the document).

  window.addEventListener('focus', $49c2914eac614f98$var$handleFocusEvent, true);
  window.addEventListener('blur', $49c2914eac614f98$var$handleWindowBlur, false);

  if (typeof PointerEvent !== 'undefined') {
    document.addEventListener('pointerdown', $49c2914eac614f98$var$handlePointerEvent, true);
    document.addEventListener('pointermove', $49c2914eac614f98$var$handlePointerEvent, true);
    document.addEventListener('pointerup', $49c2914eac614f98$var$handlePointerEvent, true);
  } else {
    document.addEventListener('mousedown', $49c2914eac614f98$var$handlePointerEvent, true);
    document.addEventListener('mousemove', $49c2914eac614f98$var$handlePointerEvent, true);
    document.addEventListener('mouseup', $49c2914eac614f98$var$handlePointerEvent, true);
  }

  $49c2914eac614f98$var$hasSetupGlobalListeners = true;
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') $49c2914eac614f98$var$setupGlobalFocusEvents();else document.addEventListener('DOMContentLoaded', $49c2914eac614f98$var$setupGlobalFocusEvents);
}

function $49c2914eac614f98$export$b9b3dfddab17db27() {
  return $49c2914eac614f98$var$currentModality !== 'pointer';
}

function $49c2914eac614f98$export$630ff653c5ada6a9() {
  return $49c2914eac614f98$var$currentModality;
}

function $49c2914eac614f98$export$8397ddfc504fdb9a(modality) {
  $49c2914eac614f98$var$currentModality = modality;
  $49c2914eac614f98$var$triggerChangeHandlers(modality, null);
}

function $49c2914eac614f98$export$98e20ec92f614cfe() {
  $49c2914eac614f98$var$setupGlobalFocusEvents();

  var _$d6MJ8$useState3 = $d6MJ8$useState($49c2914eac614f98$var$currentModality),
      _$d6MJ8$useState4 = _slicedToArray(_$d6MJ8$useState3, 2),
      modality = _$d6MJ8$useState4[0],
      setModality = _$d6MJ8$useState4[1];

  $d6MJ8$useEffect(function () {
    var handler = function handler() {
      setModality($49c2914eac614f98$var$currentModality);
    };

    $49c2914eac614f98$var$changeHandlers.add(handler);
    return function () {
      $49c2914eac614f98$var$changeHandlers.delete(handler);
    };
  }, []);
  return modality;
}
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */


function $49c2914eac614f98$var$isKeyboardFocusEvent(isTextInput, modality, e) {
  return !(isTextInput && modality === 'keyboard' && e instanceof KeyboardEvent && !$49c2914eac614f98$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}

function $49c2914eac614f98$export$ffd9e5021c1fb2d6() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isTextInput = props.isTextInput,
      autoFocus = props.autoFocus;

  var _$d6MJ8$useState5 = $d6MJ8$useState(autoFocus || $49c2914eac614f98$export$b9b3dfddab17db27()),
      _$d6MJ8$useState6 = _slicedToArray(_$d6MJ8$useState5, 2),
      isFocusVisibleState = _$d6MJ8$useState6[0],
      setFocusVisible = _$d6MJ8$useState6[1];

  $49c2914eac614f98$export$ec71b4b83ac08ec3(function ($49c2914eac614f98$export$b9b3dfddab17db27) {
    setFocusVisible($49c2914eac614f98$export$b9b3dfddab17db27);
  }, [isTextInput], {
    isTextInput: isTextInput
  });
  return {
    isFocusVisible: isFocusVisibleState
  };
}

function $49c2914eac614f98$export$ec71b4b83ac08ec3(fn, deps, opts) {
  $49c2914eac614f98$var$setupGlobalFocusEvents();
  $d6MJ8$useEffect(function () {
    var handler = function handler(modality, e) {
      if (!$49c2914eac614f98$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e)) return;
      fn($49c2914eac614f98$export$b9b3dfddab17db27());
    };

    $49c2914eac614f98$var$changeHandlers.add(handler);
    return function () {
      $49c2914eac614f98$var$changeHandlers.delete(handler);
    };
  }, deps);
}

var $628b0269fe4ddcdd$exports = {};
$parcel$export($628b0269fe4ddcdd$exports, "useFocusWithin", function () {
  return $628b0269fe4ddcdd$export$420e68273165f4ec;
});

function $628b0269fe4ddcdd$export$420e68273165f4ec(props) {
  var state = $d6MJ8$useRef({
    isFocusWithin: false
  }).current;
  if (props.isDisabled) return {
    focusWithinProps: {}
  };

  var onFocus = function onFocus(e) {
    if (!state.isFocusWithin) {
      if (props.onFocusWithin) props.onFocusWithin(e);
      if (props.onFocusWithinChange) props.onFocusWithinChange(true);
      state.isFocusWithin = true;
    }
  };

  var onBlur = function onBlur(e) {
    // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
    // when moving focus inside the element. Only trigger if the currentTarget doesn't
    // include the relatedTarget (where focus is moving).
    if (state.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
      if (props.onBlurWithin) props.onBlurWithin(e);
      if (props.onFocusWithinChange) props.onFocusWithinChange(false);
      state.isFocusWithin = false;
    }
  };

  return {
    focusWithinProps: {
      onFocus: onFocus,
      onBlur: onBlur
    }
  };
}

var $bf566e5397a9742e$exports = {};
$parcel$export($bf566e5397a9742e$exports, "useHover", function () {
  return $bf566e5397a9742e$export$ae780daf29e6d456;
}); // iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.

var $bf566e5397a9742e$var$globalIgnoreEmulatedMouseEvents = false;
var $bf566e5397a9742e$var$hoverCount = 0;

function $bf566e5397a9742e$var$setGlobalIgnoreEmulatedMouseEvents() {
  $bf566e5397a9742e$var$globalIgnoreEmulatedMouseEvents = true; // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
  // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
  // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
  // the distant future because a user previously touched the element.

  setTimeout(function () {
    $bf566e5397a9742e$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}

function $bf566e5397a9742e$var$handleGlobalPointerEvent(e) {
  if (e.pointerType === 'touch') $bf566e5397a9742e$var$setGlobalIgnoreEmulatedMouseEvents();
}

function $bf566e5397a9742e$var$setupGlobalTouchEvents() {
  if (typeof document === 'undefined') return;
  if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $bf566e5397a9742e$var$handleGlobalPointerEvent);else document.addEventListener('touchend', $bf566e5397a9742e$var$setGlobalIgnoreEmulatedMouseEvents);
  $bf566e5397a9742e$var$hoverCount++;
  return function () {
    $bf566e5397a9742e$var$hoverCount--;
    if ($bf566e5397a9742e$var$hoverCount > 0) return;
    if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $bf566e5397a9742e$var$handleGlobalPointerEvent);else document.removeEventListener('touchend', $bf566e5397a9742e$var$setGlobalIgnoreEmulatedMouseEvents);
  };
}

function $bf566e5397a9742e$export$ae780daf29e6d456(props) {
  var onHoverStart = props.onHoverStart,
      onHoverChange = props.onHoverChange,
      onHoverEnd = props.onHoverEnd,
      isDisabled = props.isDisabled;

  var _$d6MJ8$useState7 = $d6MJ8$useState(false),
      _$d6MJ8$useState8 = _slicedToArray(_$d6MJ8$useState7, 2),
      isHovered = _$d6MJ8$useState8[0],
      setHovered = _$d6MJ8$useState8[1];

  var state = $d6MJ8$useRef({
    isHovered: false,
    ignoreEmulatedMouseEvents: false,
    pointerType: '',
    target: null
  }).current;
  $d6MJ8$useEffect($bf566e5397a9742e$var$setupGlobalTouchEvents, []);

  var _$d6MJ8$useMemo = $d6MJ8$useMemo(function () {
    var triggerHoverStart = function triggerHoverStart(event, pointerType) {
      state.pointerType = pointerType;
      if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
      state.isHovered = true;
      var target = event.currentTarget;
      state.target = target;
      if (onHoverStart) onHoverStart({
        type: 'hoverstart',
        target: target,
        pointerType: pointerType
      });
      if (onHoverChange) onHoverChange(true);
      setHovered(true);
    };

    var triggerHoverEnd = function triggerHoverEnd(event, pointerType) {
      state.pointerType = '';
      state.target = null;
      if (pointerType === 'touch' || !state.isHovered) return;
      state.isHovered = false;
      var target = event.currentTarget;
      if (onHoverEnd) onHoverEnd({
        type: 'hoverend',
        target: target,
        pointerType: pointerType
      });
      if (onHoverChange) onHoverChange(false);
      setHovered(false);
    };

    var hoverProps = {};

    if (typeof PointerEvent !== 'undefined') {
      hoverProps.onPointerEnter = function (e) {
        if ($bf566e5397a9742e$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
        triggerHoverStart(e, e.pointerType);
      };

      hoverProps.onPointerLeave = function (e) {
        if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
      };
    } else {
      hoverProps.onTouchStart = function () {
        state.ignoreEmulatedMouseEvents = true;
      };

      hoverProps.onMouseEnter = function (e) {
        if (!state.ignoreEmulatedMouseEvents && !$bf566e5397a9742e$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, 'mouse');
        state.ignoreEmulatedMouseEvents = false;
      };

      hoverProps.onMouseLeave = function (e) {
        if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, 'mouse');
      };
    }

    return {
      hoverProps: hoverProps,
      triggerHoverEnd: triggerHoverEnd
    };
  }, [onHoverStart, onHoverChange, onHoverEnd, isDisabled, state]),
      hoverProps1 = _$d6MJ8$useMemo.hoverProps,
      triggerHoverEnd1 = _$d6MJ8$useMemo.triggerHoverEnd;

  $d6MJ8$useEffect(function () {
    // Call the triggerHoverEnd as soon as isDisabled changes to true
    // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
    if (isDisabled) triggerHoverEnd1({
      currentTarget: state.target
    }, state.pointerType);
  }, [isDisabled]);
  return {
    hoverProps: hoverProps1,
    isHovered: isHovered
  };
}

var $45105cf6ad39191a$exports = {};
$parcel$export($45105cf6ad39191a$exports, "useInteractOutside", function () {
  return $45105cf6ad39191a$export$872b660ac5a1ff98;
});

function $45105cf6ad39191a$export$872b660ac5a1ff98(props) {
  var ref = props.ref,
      onInteractOutside = props.onInteractOutside,
      isDisabled = props.isDisabled,
      onInteractOutsideStart = props.onInteractOutsideStart;
  var stateRef = $d6MJ8$useRef({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false,
    onInteractOutside: onInteractOutside,
    onInteractOutsideStart: onInteractOutsideStart
  });
  var state = stateRef.current;
  state.onInteractOutside = onInteractOutside;
  state.onInteractOutsideStart = onInteractOutsideStart;
  $d6MJ8$useEffect(function () {
    if (isDisabled) return;

    var onPointerDown = function onPointerDown(e) {
      if ($45105cf6ad39191a$var$isValidEvent(e, ref) && state.onInteractOutside) {
        if (state.onInteractOutsideStart) state.onInteractOutsideStart(e);
        state.isPointerDown = true;
      }
    }; // Use pointer events if available. Otherwise, fall back to mouse and touch events.


    if (typeof PointerEvent !== 'undefined') {
      var onPointerUp = function onPointerUp(e) {
        if (state.isPointerDown && state.onInteractOutside && $45105cf6ad39191a$var$isValidEvent(e, ref)) {
          state.isPointerDown = false;
          state.onInteractOutside(e);
        }
      }; // changing these to capture phase fixed combobox


      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('pointerup', onPointerUp, true);
      return function () {
        document.removeEventListener('pointerdown', onPointerDown, true);
        document.removeEventListener('pointerup', onPointerUp, true);
      };
    } else {
      var onMouseUp = function onMouseUp(e) {
        if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;else if (state.isPointerDown && state.onInteractOutside && $45105cf6ad39191a$var$isValidEvent(e, ref)) {
          state.isPointerDown = false;
          state.onInteractOutside(e);
        }
      };

      var onTouchEnd = function onTouchEnd(e) {
        state.ignoreEmulatedMouseEvents = true;

        if (state.onInteractOutside && state.isPointerDown && $45105cf6ad39191a$var$isValidEvent(e, ref)) {
          state.isPointerDown = false;
          state.onInteractOutside(e);
        }
      };

      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('mouseup', onMouseUp, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('touchend', onTouchEnd, true);
      return function () {
        document.removeEventListener('mousedown', onPointerDown, true);
        document.removeEventListener('mouseup', onMouseUp, true);
        document.removeEventListener('touchstart', onPointerDown, true);
        document.removeEventListener('touchend', onTouchEnd, true);
      };
    }
  }, [ref, state, isDisabled]);
}

function $45105cf6ad39191a$var$isValidEvent(event, ref) {
  if (event.button > 0) return false; // if the event target is no longer in the document

  if (event.target) {
    var ownerDocument = event.target.ownerDocument;
    if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
  }

  return ref.current && !ref.current.contains(event.target);
}

var $4e806c4e858ad73c$exports = {};
$parcel$export($4e806c4e858ad73c$exports, "useKeyboard", function () {
  return $4e806c4e858ad73c$export$8f71654801c2f7cd;
});

function $014803b002f7750a$export$48d1ea6320830260(handler) {
  if (!handler) return;
  var shouldStopPropagation = true;
  return function (e) {
    var event = _objectSpread(_objectSpread({}, e), {}, {
      preventDefault: function preventDefault() {
        e.preventDefault();
      },
      isDefaultPrevented: function isDefaultPrevented() {
        return e.isDefaultPrevented();
      },
      stopPropagation: function stopPropagation() {
        console.error('stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.');
      },
      continuePropagation: function continuePropagation() {
        shouldStopPropagation = false;
      }
    });

    handler(event);
    if (shouldStopPropagation) e.stopPropagation();
  };
}

function $4e806c4e858ad73c$export$8f71654801c2f7cd(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: $014803b002f7750a$export$48d1ea6320830260(props.onKeyDown),
      onKeyUp: $014803b002f7750a$export$48d1ea6320830260(props.onKeyUp)
    }
  };
}

var $8e3cc0943caa61b7$exports = {};
$parcel$export($8e3cc0943caa61b7$exports, "useMove", function () {
  return $8e3cc0943caa61b7$export$36da96379f79f245;
});

function $8e3cc0943caa61b7$export$36da96379f79f245(props) {
  var onMoveStart = props.onMoveStart,
      onMove = props.onMove,
      onMoveEnd = props.onMoveEnd;
  var state = $d6MJ8$useRef({
    didMove: false,
    lastPosition: null,
    id: null
  });

  var _$d6MJ8$useGlobalList2 = $d6MJ8$useGlobalListeners(),
      addGlobalListener = _$d6MJ8$useGlobalList2.addGlobalListener,
      removeGlobalListener = _$d6MJ8$useGlobalList2.removeGlobalListener;

  var moveProps1 = $d6MJ8$useMemo(function () {
    var moveProps = {};

    var start = function start() {
      $cd0dbdeabf637843$export$16a4697467175487();
      state.current.didMove = false;
    };

    var move = function move(originalEvent, pointerType, deltaX, deltaY) {
      if (deltaX === 0 && deltaY === 0) return;

      if (!state.current.didMove) {
        state.current.didMove = true;
        onMoveStart === null || onMoveStart === void 0 ? void 0 : onMoveStart({
          type: 'movestart',
          pointerType: pointerType,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey,
          altKey: originalEvent.altKey
        });
      }

      onMove({
        type: 'move',
        pointerType: pointerType,
        deltaX: deltaX,
        deltaY: deltaY,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };

    var end = function end(originalEvent, pointerType) {
      $cd0dbdeabf637843$export$b0d6fa1ab32e3295();
      if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 ? void 0 : onMoveEnd({
        type: 'moveend',
        pointerType: pointerType,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };

    if (typeof PointerEvent === 'undefined') {
      var onMouseMove = function onMouseMove(e) {
        if (e.button === 0) {
          move(e, 'mouse', e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
          state.current.lastPosition = {
            pageX: e.pageX,
            pageY: e.pageY
          };
        }
      };

      var onMouseUp = function onMouseUp(e) {
        if (e.button === 0) {
          end(e, 'mouse');
          removeGlobalListener(window, 'mousemove', onMouseMove, false);
          removeGlobalListener(window, 'mouseup', onMouseUp, false);
        }
      };

      moveProps.onMouseDown = function (e) {
        if (e.button === 0) {
          start();
          e.stopPropagation();
          e.preventDefault();
          state.current.lastPosition = {
            pageX: e.pageX,
            pageY: e.pageY
          };
          addGlobalListener(window, 'mousemove', onMouseMove, false);
          addGlobalListener(window, 'mouseup', onMouseUp, false);
        }
      };

      var onTouchMove = function onTouchMove(e) {
        var touch = _toConsumableArray(e.changedTouches).findIndex(function (_ref3) {
          var identifier = _ref3.identifier;
          return identifier === state.current.id;
        });

        if (touch >= 0) {
          var _e$changedTouches$tou = e.changedTouches[touch],
              pageX = _e$changedTouches$tou.pageX,
              pageY = _e$changedTouches$tou.pageY;
          move(e, 'touch', pageX - state.current.lastPosition.pageX, pageY - state.current.lastPosition.pageY);
          state.current.lastPosition = {
            pageX: pageX,
            pageY: pageY
          };
        }
      };

      var onTouchEnd = function onTouchEnd(e) {
        var touch = _toConsumableArray(e.changedTouches).findIndex(function (_ref4) {
          var identifier = _ref4.identifier;
          return identifier === state.current.id;
        });

        if (touch >= 0) {
          end(e, 'touch');
          state.current.id = null;
          removeGlobalListener(window, 'touchmove', onTouchMove);
          removeGlobalListener(window, 'touchend', onTouchEnd);
          removeGlobalListener(window, 'touchcancel', onTouchEnd);
        }
      };

      moveProps.onTouchStart = function (e) {
        if (e.changedTouches.length === 0 || state.current.id != null) return;
        var _e$changedTouches$ = e.changedTouches[0],
            pageX = _e$changedTouches$.pageX,
            pageY = _e$changedTouches$.pageY,
            identifier = _e$changedTouches$.identifier;
        start();
        e.stopPropagation();
        e.preventDefault();
        state.current.lastPosition = {
          pageX: pageX,
          pageY: pageY
        };
        state.current.id = identifier;
        addGlobalListener(window, 'touchmove', onTouchMove, false);
        addGlobalListener(window, 'touchend', onTouchEnd, false);
        addGlobalListener(window, 'touchcancel', onTouchEnd, false);
      };
    } else {
      var onPointerMove = function onPointerMove(e) {
        if (e.pointerId === state.current.id) {
          var pointerType = e.pointerType || 'mouse'; // Problems with PointerEvent#movementX/movementY:
          // 1. it is always 0 on macOS Safari.
          // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS

          move(e, pointerType, e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
          state.current.lastPosition = {
            pageX: e.pageX,
            pageY: e.pageY
          };
        }
      };

      var onPointerUp = function onPointerUp(e) {
        if (e.pointerId === state.current.id) {
          var pointerType = e.pointerType || 'mouse';
          end(e, pointerType);
          state.current.id = null;
          removeGlobalListener(window, 'pointermove', onPointerMove, false);
          removeGlobalListener(window, 'pointerup', onPointerUp, false);
          removeGlobalListener(window, 'pointercancel', onPointerUp, false);
        }
      };

      moveProps.onPointerDown = function (e) {
        if (e.button === 0 && state.current.id == null) {
          start();
          e.stopPropagation();
          e.preventDefault();
          state.current.lastPosition = {
            pageX: e.pageX,
            pageY: e.pageY
          };
          state.current.id = e.pointerId;
          addGlobalListener(window, 'pointermove', onPointerMove, false);
          addGlobalListener(window, 'pointerup', onPointerUp, false);
          addGlobalListener(window, 'pointercancel', onPointerUp, false);
        }
      };
    }

    var triggerKeyboardMove = function triggerKeyboardMove(e, deltaX, deltaY) {
      start();
      move(e, 'keyboard', deltaX, deltaY);
      end(e, 'keyboard');
    };

    moveProps.onKeyDown = function (e) {
      switch (e.key) {
        case 'Left':
        case 'ArrowLeft':
          e.preventDefault();
          e.stopPropagation();
          triggerKeyboardMove(e, -1, 0);
          break;

        case 'Right':
        case 'ArrowRight':
          e.preventDefault();
          e.stopPropagation();
          triggerKeyboardMove(e, 1, 0);
          break;

        case 'Up':
        case 'ArrowUp':
          e.preventDefault();
          e.stopPropagation();
          triggerKeyboardMove(e, 0, -1);
          break;

        case 'Down':
        case 'ArrowDown':
          e.preventDefault();
          e.stopPropagation();
          triggerKeyboardMove(e, 0, 1);
          break;
      }
    };

    return moveProps;
  }, [state, onMoveStart, onMove, onMoveEnd, addGlobalListener, removeGlobalListener]);
  return {
    moveProps: moveProps1
  };
}

var $d889b4c7bb142e6b$exports = {};
$parcel$export($d889b4c7bb142e6b$exports, "useScrollWheel", function () {
  return $d889b4c7bb142e6b$export$2123ff2b87c81ca;
});

function $d889b4c7bb142e6b$export$2123ff2b87c81ca(props, ref) {
  var onScroll = props.onScroll,
      isDisabled = props.isDisabled;
  var onScrollHandler = $d6MJ8$useCallback(function (e) {
    // If the ctrlKey is pressed, this is a zoom event, do nothing.
    if (e.ctrlKey) return; // stop scrolling the page

    e.preventDefault();
    e.stopPropagation();
    if (onScroll) onScroll({
      deltaX: e.deltaX,
      deltaY: e.deltaY
    });
  }, [onScroll]);
  $d6MJ8$useEvent(ref, 'wheel', isDisabled ? null : onScrollHandler);
}

var $6f6a8f8f8557a728$exports = {};
$parcel$export($6f6a8f8f8557a728$exports, "useLongPress", function () {
  return $6f6a8f8f8557a728$export$c24ed0104d07eab9;
});
var $6f6a8f8f8557a728$var$DEFAULT_THRESHOLD = 500;

function $6f6a8f8f8557a728$export$c24ed0104d07eab9(props) {
  var isDisabled = props.isDisabled,
      onLongPressStart = props.onLongPressStart,
      onLongPressEnd = props.onLongPressEnd,
      onLongPress = props.onLongPress,
      _props$threshold = props.threshold,
      threshold = _props$threshold === void 0 ? $6f6a8f8f8557a728$var$DEFAULT_THRESHOLD : _props$threshold,
      accessibilityDescription = props.accessibilityDescription;
  var timeRef = $d6MJ8$useRef(null);

  var _$d6MJ8$useGlobalList3 = $d6MJ8$useGlobalListeners(),
      addGlobalListener = _$d6MJ8$useGlobalList3.addGlobalListener,
      removeGlobalListener = _$d6MJ8$useGlobalList3.removeGlobalListener;

  var _$b468497b34dcb8dd$ex2 = $b468497b34dcb8dd$export$45712eceda6fad21({
    isDisabled: isDisabled,
    onPressStart: function onPressStart(e1) {
      if (e1.pointerType === 'mouse' || e1.pointerType === 'touch') {
        if (onLongPressStart) onLongPressStart(_objectSpread(_objectSpread({}, e1), {}, {
          type: 'longpressstart'
        }));
        timeRef.current = setTimeout(function () {
          // Prevent other usePress handlers from also handling this event.
          e1.target.dispatchEvent(new PointerEvent('pointercancel', {
            bubbles: true
          }));
          if (onLongPress) onLongPress(_objectSpread(_objectSpread({}, e1), {}, {
            type: 'longpress'
          }));
          timeRef.current = null;
        }, threshold); // Prevent context menu, which may be opened on long press on touch devices

        if (e1.pointerType === 'touch') {
          var onContextMenu = function onContextMenu(e) {
            e.preventDefault();
          };

          addGlobalListener(e1.target, 'contextmenu', onContextMenu, {
            once: true
          });
          addGlobalListener(window, 'pointerup', function () {
            // If no contextmenu event is fired quickly after pointerup, remove the handler
            // so future context menu events outside a long press are not prevented.
            setTimeout(function () {
              removeGlobalListener(e1.target, 'contextmenu', onContextMenu);
            }, 30);
          }, {
            once: true
          });
        }
      }
    },
    onPressEnd: function onPressEnd(e) {
      if (timeRef.current) clearTimeout(timeRef.current);
      if (onLongPressEnd && (e.pointerType === 'mouse' || e.pointerType === 'touch')) onLongPressEnd(_objectSpread(_objectSpread({}, e), {}, {
        type: 'longpressend'
      }));
    }
  }),
      pressProps = _$b468497b34dcb8dd$ex2.pressProps;

  var descriptionProps = $d6MJ8$useDescription(onLongPress && !isDisabled ? accessibilityDescription : null);
  return {
    longPressProps: $d6MJ8$mergeProps(pressProps, descriptionProps)
  };
}

export { $28aa772934c24805$export$27c701ed9e449e99 as Pressable, $68900e0904c93fdc$export$3351871ee4b288b8 as PressResponder, $226b63c52f1613ce$export$f8168d8dd8fd66e6 as useFocus, $49c2914eac614f98$export$b9b3dfddab17db27 as isFocusVisible, $49c2914eac614f98$export$630ff653c5ada6a9 as getInteractionModality, $49c2914eac614f98$export$8397ddfc504fdb9a as setInteractionModality, $49c2914eac614f98$export$98e20ec92f614cfe as useInteractionModality, $49c2914eac614f98$export$ffd9e5021c1fb2d6 as useFocusVisible, $49c2914eac614f98$export$ec71b4b83ac08ec3 as useFocusVisibleListener, $628b0269fe4ddcdd$export$420e68273165f4ec as useFocusWithin, $bf566e5397a9742e$export$ae780daf29e6d456 as useHover, $45105cf6ad39191a$export$872b660ac5a1ff98 as useInteractOutside, $4e806c4e858ad73c$export$8f71654801c2f7cd as useKeyboard, $8e3cc0943caa61b7$export$36da96379f79f245 as useMove, $b468497b34dcb8dd$export$45712eceda6fad21 as usePress, $d889b4c7bb142e6b$export$2123ff2b87c81ca as useScrollWheel, $6f6a8f8f8557a728$export$c24ed0104d07eab9 as useLongPress };